// extracted by mini-css-extract-plugin
export default {"cardWrapper":"cardWrapper_ClassificationTopConcernsByAreaHOC-module_PQ9fU","headerTitle":"headerTitle_ClassificationTopConcernsByAreaHOC-module_SE2Au"};